import { render, staticRenderFns } from "./customerFrom.vue?vue&type=template&id=2f38f152&scoped=true"
import script from "./customerFrom.vue?vue&type=script&lang=js"
export * from "./customerFrom.vue?vue&type=script&lang=js"
import style0 from "./customerFrom.vue?vue&type=style&index=0&id=2f38f152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38f152",
  null
  
)

export default component.exports